(function(){
  function DrawerToggle(node) {
    this.node = node;
    this.primary = node.querySelector('[data-primary-container]');
    this.toggles = node.querySelectorAll('[data-item="toggle"]');

    this.init();
  }

  DrawerToggle.prototype.init = function() {
    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();

        const link = e.currentTarget;
        const menuBefore = link.closest('[data-list-item]').closest('ul');
        const childMenu = link.nextElementSibling;
        const isOpen = link.getAttribute('aria-expanded') != 'true';
        const firstFocusable = isOpen ? childMenu.querySelector('.drawer-menu__link') : menuBefore.querySelector('.drawer-menu__link');
        const depth = menuBefore.classList.contains('drawer-menu-list--1') ? 1 : (menuBefore.classList.contains('drawer-menu-list--2') ? 2 : 0);

        menuBefore.querySelectorAll('[aria-expanded="true"]').forEach(el => {
          el.setAttribute('aria-expanded', false);
          el.parentNode.classList.remove('child-visible');
        });
        menuBefore.querySelectorAll('[aria-hidden="false"]').forEach(el => {
          el.setAttribute('aria-hidden', true);
          el.classList.remove('visible');
        });

        if (isOpen) {
          childMenu.classList.add('visible');
          link.parentNode.classList.add('child-visible');

          if (childMenu.hasAttribute('data-search-menu')) {
            this.node.classList.add('search-active');
          }

          this.navigate(depth + 1);

          link.setAttribute('aria-expanded', true);
          childMenu.setAttribute('aria-hidden', false);
        } else {
          if (childMenu.hasAttribute('data-search-menu')) {
            this.node.classList.remove('search-active');
          }

          this.navigate(depth);
        }

        setTimeout(() => {
          firstFocusable.focus();
        }, 50);
      })
    })
  };

  DrawerToggle.prototype.navigate = function (depth) {
    linksDepth = depth;
    this.node.setAttribute('data-depth', depth);
    this.primary.setAttribute('data-depth', depth);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('[data-drawer-menu]') && new DrawerToggle(document.querySelector('[data-drawer-menu]'));
  })
})();